import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { register } from './registerServiceWorker';
import './utils/devToolsProtection'; // 🛡️ Proteção anti-DevTools

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
register();